export default __webpack_public_path__ + "static/media/flag_antarctica.85acc07a.svg";